import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadPlans } from "../../actions";
import { CancelIcon, RefreshCircleIcon } from "../../icon";
import { FeaturesModel } from "../../models/features.model";
import { PhoneNumberModel } from "../../models/phone-number.model";
import { PlanModel, PlanType, TierOccurrence, } from "../../models/plans.model";
import { PlanHistoryModel, RechargeStatus } from "../../models/transaction-history.model";
import * as selector from "../../selectors/selectors";
import { UtilityService } from '../../services/UtilityService';
import AddOn from "../plans/add-on.component";
import ButtonComponent from "../shared/button/button.component";
import { ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import TierLoader from "../shared/loaders/tiers-loader.json";

interface IProps  {
    IsSignUp?: boolean;
    PhonePlans?: PlanHistoryModel[];
    HandleNext?: (data: { Addons: IAddonSelctionData, AddonOccurrence: TierOccurrence | -1; }) => void;
    Stepdata?: any;
}
interface IAddonSelctionData {
    [ID: string]: number;
}

const SelectAddon = (props: IProps) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const Features: FeaturesModel[] = useSelector(selector.features)
    const Plans : PlanModel[] = useSelector(selector.plans)
    const LoadingPlans: boolean = useSelector(selector.loadingPlans)
    const  LoadingFeatures: boolean = useSelector(selector.loadingFeatures)

    const [maxSelection, setMaxSelection] = useState<number>(10);
    const [addonOccurrence, setAddonOccurrence] = useState<TierOccurrence | -1>(-1);
    const [addonSelection, setAddonSelection] = useState<IAddonSelctionData>({});
    const [confirm, setConfirm] = useState<boolean>(false)
    const [skipClicked, setSkipClicked] = useState(false);

    const [currentPhoneNumber, setcurrentPhoneNumber] = useState<PhoneNumberModel>(PhoneNumbers.find((phoneNumber) => phoneNumber.ID === state?.PhoneNumberID));
    const [phoneNumberDetails, setPhoneNumberDetails] = useState<{
        PhoneNumber: string,
        Plan: string,
        planPrice: number,
        Date: string
    }>({
        PhoneNumber: currentPhoneNumber?.PhoneNumber,
        Plan: !!state.Plan ? state.Plan.Name : !!props.Stepdata?.Plan ? props.Stepdata.Plan.Name : "",
        planPrice: !!state.Plan ? state.Tenure === "A" ? state.Plan.YearlyPrice : state.Plan.Price :
            !!props.Stepdata?.Plan ? props.Stepdata?.Tenure === "A" ? props.Stepdata?.Plan.YearlyPrice : props.Stepdata?.Plan.Price : 0,
        Date: new Date().toISOString().slice(0, 10)
    })
    const [selectedAddon, setSelectedAddon] = useState<{
        AddonID: string,
        AddonPrice: number,
        AddonName: string,
        AddonCount: number
    }[]>([])

    const getprice = () => {
        let price = 0
        if (!!props.Stepdata?.Plan) {
            price = phoneNumberDetails.planPrice
            if (!!selectedAddon) {
                price += selectedAddon.reduce((sum, addon) => sum + (addon.AddonPrice * addon.AddonCount), 0)
            }
        }
        else {
            price = selectedAddon.reduce((sum, addon) => sum + addon.AddonPrice * addon.AddonCount, 0)
        }
        setTotalPrice(Number(price.toFixed(2)))
    }


    const [totalPrice, setTotalPrice] = useState<number>()
    const getFilteredPlans = () => {
        const phonePlans = state.PhonePlans as PlanHistoryModel[] || props.PhonePlans;

        let plans = Plans?.filter(x => !x.IsDeleted && (state.ProductType === x.Product) && x.Type === PlanType.ADD_ON)?.filter(x => (!state.IsAddonRecharge && x.TierOccurrence === TierOccurrence.RECURRING) || state.IsAddonRecharge).filter(addon => addon.SelectedOrganizations?.length > 0 ? (addon.SelectedOrganizations as string[])?.includes(state.Organization.ID) : addon)

        if (state.IsAddonRecharge && !state.IsSignUp) {
            let oneOnOneTextingFeatureID = Features?.find(x => x.Code === "CPMF")?.ID
            let groupTextingFeatureID = Features?.find(x => x.Code === "GTF")?.ID
            let endUserFeatureID = Features?.find(x => x.Code === "EUCF")?.ID

            let currentPlanItem = phonePlans?.find(x => x.PlanID === (state?.CurrentPlanID || props.Stepdata?.Plan.PlanID) && x.StatusType === RechargeStatus.ONGOING);
            let currentPlan = currentPlanItem?.Plan;

            if (!!currentPlanItem?.IsItemCancelled) {
                plans = plans?.filter(x => x.Type === PlanType.ADD_ON && x.TierOccurrence !== TierOccurrence.RECURRING)
            }

            if (!!currentPlan && (currentPlan?.Features?.find(y => y.ID === oneOnOneTextingFeatureID)?.Value === "-1" || currentPlan?.Features?.find(y => y.ID === oneOnOneTextingFeatureID)?.Value === "Unlimited")) {
                plans = plans?.filter(x => !(x.Type === PlanType.ADD_ON && x.Features[0]?.ID === oneOnOneTextingFeatureID))
            }

            if (!!currentPlan && (currentPlan?.Features?.find(y => y.ID === groupTextingFeatureID)?.Value === "-1" || currentPlan?.Features?.find(y => y.ID === groupTextingFeatureID)?.Value === "Unlimited")) {
                plans = plans?.filter(x => !(x.Type === PlanType.ADD_ON && x.Features[0]?.ID === groupTextingFeatureID))
            }

            if (!!currentPlan && (currentPlan?.Features?.find(y => y.ID === endUserFeatureID)?.Value === "-1" || currentPlan?.Features?.find(y => y.ID === endUserFeatureID)?.Value === "Unlimited")) {
                plans = plans?.filter(x => !(x.Type === PlanType.ADD_ON && x.Features[0]?.ID === endUserFeatureID))
            }
        }
        return plans;
    }

    const [filteredPlans, setFilteredPlans] = useState<PlanModel[]>(getFilteredPlans());
    const handleAddonSelection = (planID: string, count: number) => {
        let addon = filteredPlans?.find(x => x.PlanID === planID);
        if (!!(addon && addon.TierOccurrence)) {

            setAddonOccurrence(addon.TierOccurrence)
        }
        let data = { ...addonSelection, [planID]: count };
        let keys = Object.keys(data)?.filter(key => data[key] > 0);
        let output: any = {};
        keys.forEach(key => {
            output[key] = data[key];
        });

        if (Object.keys(output)?.length === 0) {
            setAddonOccurrence(-1)
        }
        setAddonSelection(output);
        (global as any).paymentID = "";

        if (selectedAddon?.find(x => x.AddonID === planID)) {
            let addon = selectedAddon.find(x => x.AddonID === planID)
            addon.AddonCount = count
        }
        else {
            let newAddon = {
                AddonID: planID,
                AddonPrice: addon.Price * count,
                AddonCount: count,
                AddonName: addon.Name
            }
            setSelectedAddon((prevState) => ([...prevState, newAddon]));
        }
    }

    useEffect(() => {
        setMaxSelection((10 - getSelectedAddonCount()) > 0 ? 10 - getSelectedAddonCount() : 0);
        getprice()

    }, [addonSelection])

    const getSelectedAddonCount = () => {
        return Object.values(addonSelection)?.reduce((p, c) => p + c, 0) || 0;
    }

    useEffect(() => {
        if (!state.Plan && !state.IsAddonRecharge) {
            const activeStep = (location.state as any)?.step || 1;
            navigate(location.pathname, { state: { ...(location.state as any), step: activeStep - 1 }, replace: true })
        }
    }, [])

    useEffect(() => {
        LoadPlans(dispatch)
    }, [])

    useEffect(() => {
        setFilteredPlans(getFilteredPlans())
    }, [Plans])


    const handleClose = () => {
        setConfirm(false)
    }

    const handleconfirm = () => {
        setConfirm(false);
        if (skipClicked) {
            props.HandleNext({ Addons: {}, AddonOccurrence: -1 });
        } else {
            props.HandleNext({ Addons: addonSelection, AddonOccurrence: addonOccurrence });
        }
        setSkipClicked(false);

    }
    const handleSkip = () => {
        setConfirm(true);
        setSkipClicked(true);
    }

    return (
        <>
            <Grid container direction="column" >
                <Grid container direction="row" className={`mt-2 mx-0 d-flex justify-center h-58 o-y-scroll o-x-hidden`} alignItems="center">
                    {
                        LoadingPlans || LoadingFeatures ?
                            <Grid xl={3} lg={3} md={6} sm={8} item className='my-2 mx-4'>
                                <AnimateLoader LoaderAnimation={TierLoader} style={{ maxWidth: "330px" }} className={"w-p-100"} />
                            </Grid>
                            : Plans?.length > 0 ?
                                filteredPlans?.length > 0 ? filteredPlans?.map((x, i) =>
                                    <AddOn key={i} {...{ ...x, IsDeleted: (addonOccurrence as number === -1 ? false : x.TierOccurrence !== addonOccurrence) }} MaxSelection={maxSelection + (addonSelection[x.PlanID] || 0)} SelectionCount={addonSelection[x.PlanID]} ShowAddOnOptions={false} EnableAddonSelection={true} HideBuyNow={getSelectedAddonCount() >= 10} OnSelectionChange={(count: number) => handleAddonSelection(x.PlanID, count)} Index={(i + 1) % 2} />
                                )
                                    :
                                    <span className="h3-regular">{appNote.NO_ADDONS_AVAILABLE}</span>
                                : <div className="c-pointer" onClick={() => LoadPlans(dispatch)}>
                                    <div className="d-flex">
                                        <RefreshCircleIcon className="mx-auto" />
                                    </div>
                                    <div className="h4 mt-1">{appNote.CLICK_TO_REFRESH_PLANS}</div>
                                </div>
                    }
                </Grid>
                {
                    <Grid container direction="row-reverse" className={`mt-1 ${IsMobileDevice ? "mb-7" : "mb-1"}`} >
                        {
                            Plans?.length > 0 && filteredPlans?.length > 0 &&
                            <ButtonComponent ButtonLabel={"Next"}
                                OnClick={() => state.ManualPayment ? setConfirm(true) : props.HandleNext({ Addons: addonSelection, AddonOccurrence: addonOccurrence })}
                                Variant={Object.keys(addonSelection).length === 0 ? "disabled-btn" : "primary-btn"} ClassName="mr-3"></ButtonComponent>
                        }
                        {
                            (!state.IsAddonRecharge) &&
                            <span onClick={() => { (global as any).paymentID = ""; state.ManualPayment ? handleSkip() : props.HandleNext({ Addons: {}, AddonOccurrence: -1 }) }} className="my-auto mr-3 link">Skip</span>
                        }

                    </Grid>
                }
            </Grid >
            {confirm && <Dialog open={confirm} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
                classes={{ paper: "br-2 dialogue-shadow" }}>
                <DialogTitle className="" id="alert-dialog-title">
                    <div className={`d-flex`}>
                        <span className={"h2-semibold color-display-title"}>
                            Confirm Payment
                        </span>
                        <Tooltip title='Close' placement='bottom'>
                            <CancelIcon className={"c-pointer ml-auto mr-1 my-auto"} onClick={handleClose} />
                        </Tooltip>
                    </div>
                </DialogTitle>
                <div className={`bb-primary-divider-4`}></div>
                <DialogContent >
                    <Grid container >
                        <Grid item md={3} className="h5-semibold pt-1">
                            {ViewTextLabels.PHONE_NUMBER}
                        </Grid>
                        <Grid item md={9} className="h5-regular pt-1">
                            {UtilityService.maskPhoneNumber(phoneNumberDetails.PhoneNumber)}
                        </Grid>
                        {
                            !!props.Stepdata?.Plan &&
                            <Grid item container md={12}>
                                <Grid item md={3} className="h5-semibold pt-1">
                                    Plan
                                </Grid>
                                <Grid item md={8} className="h5-regular pt-1">
                                    {phoneNumberDetails.Plan}
                                </Grid>
                                <Grid item md={1} className="h5-regular pt-1 color-vigenary-light d-flex justify-center">
                                    {`$${phoneNumberDetails.planPrice}`}
                                </Grid>
                            </Grid>
                        }
                        {
                            !!selectedAddon.length &&
                            <Grid item container md={12}>
                                <Grid item md={3} className="h5-semibold pt-1">
                                    Addons
                                </Grid>
                                <Grid item md={5} className="h5-regular pt-1">
                                    {selectedAddon.map((addon, index) => (
                                        addon.AddonCount !== 0 ?
                                            <Grid item className="pt-1">
                                                {` ${addon.AddonName} x ${addon.AddonCount}`}
                                            </Grid> : ""
                                    ))}
                                </Grid>
                                <Grid item md={4} className="h5-regular pt-1 d-flex flex-direction align-end">
                                    {selectedAddon.map((addon, index) => (
                                        addon.AddonCount !== 0 ?
                                            <Grid item className="pt-1" >
                                                {`$${addon.AddonPrice} x ${addon.AddonCount} =`}<span className="color-addon-text"> {`$${addon.AddonPrice * addon.AddonCount}`}</span>
                                            </Grid> : ""

                                    ))}
                                </Grid>
                            </Grid>
                        }
                        <Grid item md={11} className="h5-semibold pt-2">
                            Total Price
                        </Grid>
                        <Grid item md={1} className="h5-regular pt-2 color-primary-success d-flex justify-center">
                            {`$${totalPrice}`}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="pb-2">
                    <ButtonComponent OnClick={(e) => { handleClose() }} ButtonLabel={buttonLabels.CANCEL} ClassName={"c-pointer mr-1"} Variant={"secondary-btn-small"} />
                    <ButtonComponent OnClick={() => handleconfirm()} ButtonLabel={buttonLabels.CONFIRM} ClassName={"c-pointer mr-2"} Variant={"primary-btn-small"} />
                </DialogActions>
            </Dialog >
            }
        </>
    )
};

export default SelectAddon;

